import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import BazarIcon from "../../../assets/bazar_pars.png";
import MyketIcon from "../../../assets/myket_pars.png";
import SibAppIcon from "../../../assets/sib_app_pars.png";
import QrcodePicture from "../../../assets/app-qrcode.png";
import { Link } from "react-router-dom";
import DappPicture from "../../../assets/Group_8271-removebg-preview.png";
import "./DownloadApplication.css";
import { useEffect } from "react";

export function DownloadApplication() {
  useEffect(() => {
    document.title = "    دانلود اپلیکیشن";
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        mx: 0,
        px: 0,
        bgcolor: "background.default",
        py: 6,
        position: "relative",
      }}
    >
      <Box className="half_shape_d_app"></Box>
      <Container maxWidth="xl">
        <Grid container>
          <Grid item xs={12} md={6}>
            <Stack
              direction="column"
              sx={{ mb: 3, justifyContent: "center", height: "100%" }}
            >
              <Grid>
                <Typography variant={"h4"}>{t("download_app")}</Typography>
                <Typography sx={{ color: "text.secondary", my: 1.5 }}>
                  {t("lorem").slice(0, 150)}
                </Typography>
              </Grid>
              <Grid sx={{ mt: 3 }}>
                <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={QrcodePicture}
                      alt="qr code picture"
                      width="auto"
                    />
                  </Box>
                  <Stack>
                    <Typography variant="subtitle1">
                      {t("scan_for_download")}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{ color: "text.secondary" }}
                    >
                      Android & Ios
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  mt={2}
                  spacing={1}
                  alignItems={{ xs: "start", sm: "center" }}
                >
                  <Link to="https://cafebazaar.ir/app/com.parsianbit.application">
                    <img src={BazarIcon} alt="icon app store" width="auto" />
                  </Link>
                  <Link to="/">
                    <Box>
                      <img src={MyketIcon} alt="icon app store" width="auto" />
                    </Box>
                  </Link>
                  <Link to="/">
                    <Box>
                      <img src={SibAppIcon} alt="icon app store" width="auto" />
                    </Box>
                  </Link>
                </Stack>
              </Grid>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} sx={{ alignSelf: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ width: { xs: "100%", md: "fit-content" } }}>
                <img src={DappPicture} alt="phone picture" width="100%" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Paper>
  );
}
